import React from "react";
import { Organisation } from "../../../../../../../Wrap/Models/Models/Customer/Organisation";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { OrganisationMemberPopUpInfo } from "../../../AddClient/Resource/Contents";
import { AccountRoleActorCategory } from "../../../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { AccountRoleStore } from "../../Store/Variable";
import { ShareOfTrustTable } from "../../Components/TrustMember/ShareOfTrustTable";
import { Title } from "../../../../../../../Wrap/Constants/Enums/Title";
import { Lightbox } from "../../../../../../../react-core/Html/Components/Lightbox";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";

interface IShareofTrustLightboxProps {
    data: Organisation;
    onClose: () => void;
    onSave: (orgnisationModel: Organisation) => void;
}

interface IShareofTrustLightboxState {
    accountId: number;
    updatedOrganisationModel: Organisation;
    orgnisationMember: Array<OrganisationMember>;
    deleteItem: OrganisationMember;
    showMessage: boolean;
}

export class ShareofTrustLightbox extends FormComponent<IShareofTrustLightboxProps, IShareofTrustLightboxState> {
    constructor(props: IShareofTrustLightboxProps) {
        super(props);
        this.state = {
            accountId: null,
            orgnisationMember: this.resettozero(),
            updatedOrganisationModel: this.resetorganisation(),
            deleteItem: this.resetdeleteitem(),
            showMessage: false,
        };
        this.subscribeToStore(AccountRoleStore, () => {
            const result = (AccountRoleStore.getData() || []).filter(
                (ele) => ele.AccountRoleType == RoleType.TrustAccountHolder
            );
            if (result.length > 0) {
                this.setState({
                    accountId: result[0].AccountId,
                });
            }
        });
    }

    isValid() {
        const flag = super.isValid();
        const { updatedOrganisationModel, showMessage } = this.state;
        let sum = 0;
        if (!CommonHelper.isNullOrEmpty(updatedOrganisationModel?.ShareOfTrustItem)) {
            updatedOrganisationModel?.ShareOfTrustItem.forEach((x) => {
                const share = x?.Percentage ? Number(x?.Percentage) : 0;
                sum = sum + share;
            });
        }

        if (Math.abs(100 - sum) > 0.1) {
            this.setState({ showMessage: true });
            return false;
        }
        return flag;
    }

    private resetdeleteitem() {
        const old: OrganisationMember = {
            Company: null,
            Individual: {
                PersonalDetails: { Title: Title.Mr },
                ActorCategory: AccountRoleActorCategory.Associate,
                ActorOwnerId: 0,
            },
            Relationships: [RelationshipType.Beneficiary],
            Percentage: 0,
        };
        return old;
    }
    private resettozero() {
        const old = this.props.data;
        old.OrganisationMembers.forEach((change) => {
            change.Percentage = 0;
        });
        return old.OrganisationMembers;
    }
    private resetorganisation() {
        const old = this.props.data;

        old.OrganisationMembers = [];
        old.Beneficiaries = [];
        old.ShareOfTrustItem = [];

        return old;
    }

    render() {
        const { accountId, updatedOrganisationModel, orgnisationMember, deleteItem } = this.state;
        const { showMessage } = this.state;
        return (
            <>
                <Lightbox
                    noOverlay={false}
                    noAutofocus={true}
                    show={true}
                    title={"Share of Trust"}
                    unclosable={false}
                    onClose={() => this.props.onClose()}
                    cssWrapper="is-default-lightbox"
                >
                    {showMessage && (
                        <Alert
                            message={OrganisationMemberPopUpInfo.shareOfTrustWarning}
                            alertType={AlertType.Warning}
                        />
                    )}
                    <ShareOfTrustTable
                        data={null}
                        onRef={(ref) => ref}
                        organisation={updatedOrganisationModel}
                        deletedBeneficiary={deleteItem}
                        remainingBeneficiaries={orgnisationMember.filter((x) =>
                            x.Relationships.includes(RelationshipType.Beneficiary)
                        )}
                        isAddBeneficiary={false}
                        IsAddAdditionalBeneficiary={true}
                        onChange={(data) => this.setState({ updatedOrganisationModel: data })}
                        accountId={accountId}
                    />

                    <br />
                    <button className="btn secondary mr-10" onClick={() => this.props.onClose()}>
                        Cancel
                    </button>
                    <button
                        className="btn primary"
                        onClick={() => {
                            if (this.isValid()) {
                                this.props.onSave(updatedOrganisationModel);
                            }
                        }}
                    >
                        Save
                    </button>
                </Lightbox>
            </>
        );
    }
}
